var map = {
	"./1-backlogo.PORTRAIT2.jpg": 352,
	"./2-group.jpg": 437,
	"./4-back_logo_2.jpg": 396,
	"./PXL_20250409_174943717.TS_exported_41823.jpg": 668,
	"./PXL_20250604_171615879~2.jpg": 741,
	"./PXL_20250928_113418962.MP~2.jpg": 7,
	"./PXL_20260109_181226241~2.jpg": 164,
	"./WhatsApp Image 2026-05-01 at 16.21.45.jpeg": 737,
	"./WhatsApp Image 2026-05-01 at 16.21.46.jpeg": 736,
	"./WhatsApp Image 2026-05-01 at 16.22.15.jpeg": 867,
	"./WhatsApp Image 2026-05-01 at 21.37.46.jpeg": 159,
	"./WhatsApp Image 2026-05-05 at 08.45.15.jpeg": 193,
	"./WhatsApp Image 2026-05-05 at 08.45.16.jpeg": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;